import React from 'react';
import { DispatchEvent, GlobalApplicationContext } from './SmartTypes';

export const GlobalContext = React.createContext({
    globalState: {},
    globalDispatch: (dispatchEvent: DispatchEvent) => {},
} as GlobalApplicationContext);
